export const submitReset = (array) => {
  if (!array) {
    return [];
  } else if (1 === array.length && 'reset' === array[0]) {
    return [];
  } else {
    return array;
  }
}